import React, { FC } from 'react';
import './CheckBoxField.css';
import { ErrorMessage, Field } from '@/Shared/Lib/Logic';

interface CheckBoxFieldProps {
	label?: string,
	name: string,
	value? : any,
	checked? : boolean,
	onChange? : (e: React.ChangeEvent<HTMLInputElement>) => void
}

const CheckBoxField: FC<CheckBoxFieldProps> = ({ label, name, value, checked = false, onChange }) => (

	<label className="CheckBoxField data-field-label" data-testid="CheckBoxField">
		
		<div className="form-group__checkbox">
			<Field
					name={name}
					type='checkbox'
					className="input-field"
					value={value}
					{...(onChange ? { onChange } : {})}
				/>
			{label && <span className='label'>{label}</span>}
			<ErrorMessage name={name} component="div" className="error-message" />
		</div>
	</label>
);

export default CheckBoxField;
